exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-class{background-color:#ddd;border:2px solid #fff}.asset-class div{padding:6px 0px 6px 15px;margin:0px}@media (min-width: 320px) and (max-width: 480px){.asset-class>div{padding:5px 0px 5px 15px}.asset-class{border:1px solid #fff}}@media (min-width: 481px) and (max-width: 761px){.asset-class>div{padding:5px 0px 5px 15px}.asset-class{border:2px solid #fff}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/Component page/LiveAsset/section1/treemapHolder.scss
// module id = 894
// module chunks = 0